import { parseISO } from 'date-fns';
import { GenerateDrivingLicenceNumber, isDLNGender } from '../..';
import { DriverDetailsFormItem } from '../../../components/manage-drivers/types';

export const isNotEmpty = (value: string | undefined) => value !== '' && value !== null && value !== undefined;

export const isEmployed = (status: string | undefined): string => {
	if (status === 'FT') {
		return 'yes';
	}
	if (status === 'PT') {
		return 'no';
	}
	return '';
};

export const getInitialDrivingLicence = (item: DriverDetailsFormItem | undefined) => {
	const tempLicence = {
		'licenceField-1': '',
		'licenceField-2': '',
		'licenceField-3': '',
		'licenceField-4': '',
	};
	if (!item) {
		return tempLicence;
	}
	if (item.licenceNumber && item.licenceNumber !== '') {
		const { licenceNumber } = item;
		tempLicence['licenceField-1'] = licenceNumber.substring(0, 5);
		tempLicence['licenceField-2'] = licenceNumber.substring(5, 11);
		tempLicence['licenceField-3'] = licenceNumber.substring(11, 14);
		tempLicence['licenceField-4'] = licenceNumber.substring(14, 16);
		return tempLicence;
	}
	if (isDLNGender.includes(item.title)) {
		const { partOne, partTwo } = GenerateDrivingLicenceNumber(item.lastNames, item.dateOfBirth, item.title);
		tempLicence['licenceField-1'] = partOne;
		tempLicence['licenceField-2'] = partTwo;
	}
	return tempLicence;
};

export const getFormDate = (value?: string | null) => {
	if (!value || value === null) {
		return { day: '', month: '', year: '' };
	}
	const tempDate = parseISO(value);
	const year = tempDate.getFullYear();
	const month = tempDate.getMonth();
	const day = tempDate.getDate();
	function minTwoDigits(n: number) {
		return (n < 10 ? '0' : '') + n.toString();
	}
	return {
		year: year.toString(),
		month: minTwoDigits(month + 1),
		day: minTwoDigits(day),
	};
};
